import { h } from "preact";

import i18n from "../../i18n";
import { getValue } from "../../helpers.js";
import officeApi from "../../api/immigrationOffice";

import Button from "../Button.jsx";
import DisplayLocation from "../DisplayLocation.jsx";
import HeaderIcon from "../HeaderIcon.jsx";
import List from "../List.jsx";
import ListItem from "../ListItem.jsx";
import { useEffect, useState } from "preact/hooks";

function createDisplayLocation(office) {
  const [name, ...rest] = office.address.split(",");

  return {
    name,
    street: rest.join(","),
    country: "Germany",
  };
}

export default {
  immigration_office_result: ({ answers, onNext, onRestart }) => {
    const [office, setOffice] = useState(null);
    useEffect(async () => {
      const data = await officeApi.fetch(
        getValue(answers.selectedImmigrationOffice)
      );
      setOffice(data.office);
    }, []);
    if (!office) return <section class="task-page">Loading …</section>;

    return (
      <section class="task-page">
        <HeaderIcon>find_immigration_office</HeaderIcon>
        <h1 class="task-page__headline">{office.name}</h1>

        <div class="task-page__content">
          <List class="mb-32">
            {office.address && (
              <ListItem iconFront="location_on">{office.address}</ListItem>
            )}
            {office.telephone && (
              <ListItem overline="phone" iconFront="phone">
                {office.telephone}
              </ListItem>
            )}
            {office.email && (
              <ListItem overline="email" iconFront="mail">
                {office.email}
              </ListItem>
            )}
            {office.fax && (
              <ListItem overline="fax" iconFront="print">
                {office.fax}
              </ListItem>
            )}
            {office.url &&
              office.url !== "http://" &&
              office.url !== "https://" && (
                <ListItem overline="website" iconFront="link" link={office.url}>
                  {office.url}
                </ListItem>
              )}
          </List>

          <DisplayLocation
            title={i18n.t("tasks.immigration_office.mapTitle")}
            location={createDisplayLocation(office)}
            class="mb-32"
          />
        </div>

        <div class="task-page__buttons">
          <Button onClick={onNext}>{i18n.t("actions.done")}</Button>
          <Button text class="mr-16" onClick={onRestart}>
            {i18n.t("actions.discard_result")}
          </Button>
        </div>
      </section>
    );
  },
};
